import { Box, HStack, ResponsiveValue } from '@chakra-ui/react';
import { Button } from '@diamond/shared/ui';
import {
  NOTE_MAX_LENGTH_DEFAULT,
  UseNoteInputReturn,
} from '@diamond/sol-buyer/utils';
import { Check as CheckIcon } from '@mui/icons-material';
import { useMemo } from 'react';

import { CloseIcon } from '../Icons';
import { NoteField } from '../NoteField';

interface CartItemNoteEditorProps {
  noteInputProps: UseNoteInputReturn['inputProps'];
  charCount: number;
  maxLength?: number;
  onCancel: () => void;
  onConfirm: () => void;
  display?: ResponsiveValue<'flex' | 'none'>;
}

export const CartItemNoteEditor = ({
  noteInputProps,
  charCount,
  maxLength = NOTE_MAX_LENGTH_DEFAULT,
  onCancel,
  onConfirm,
  display = { base: 'none', lg: 'flex' },
}: CartItemNoteEditorProps) => {
  const handleCancel = useMemo(
    () => (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onCancel();
    },
    [onCancel]
  );

  const handleConfirm = useMemo(
    () => (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onConfirm();
    },
    [onConfirm]
  );

  const handleContainerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <HStack
      display={display}
      gap="2"
      alignItems="flex-start"
      width="100%"
      maxWidth="100%"
      overflow="hidden"
      onClick={handleContainerClick}
    >
      <Box flex="1" minWidth="0" overflow="hidden">
        <NoteField
          inputProps={noteInputProps}
          charCount={charCount}
          maxLength={maxLength}
        />
      </Box>
      <HStack gap="1" flexShrink={0}>
        <Button
          variant="link"
          color="red"
          bg="#FAFAFA"
          fontWeight="semibold"
          onClick={handleCancel}
          px="8px"
          py="2px"
          h={{ base: '32px' }}
          minW="auto"
          aria-label="cancel note edit"
        >
          <CloseIcon boxSize={{ base: '14px', lg: '16px' }} />
        </Button>
        <Button
          variant="link"
          bg="#FAFAFA"
          fontWeight="semibold"
          onClick={handleConfirm}
          mt="4px"
          px="8px"
          py="2px"
          h={{ base: '32px' }}
          minW="auto"
          aria-label="confirm note edit"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CheckIcon style={{ fontSize: '14px', color: '#34C759' }} />
        </Button>
      </HStack>
    </HStack>
  );
};
